import { authHeader } from '../helpers';
import { generalConstants } from '../constants';

export const userService = {
  login,
  logout,
  register,
  getAll,
  getById,
  update,
  delete: _delete,
  forgot,
  reset
};

function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'x-api-key': generalConstants.API_KEY, 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  };

  return fetch(generalConstants.BASE_URL + 'api/user/authenticate', requestOptions)
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.user && user.user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user.user));
      }

      return user.user;
    });
}

function forgot(username) {
  const requestOptions = {
    method: 'POST',
    headers: { 'x-api-key': generalConstants.API_KEY, 'Content-Type': 'application/json' },
    body: JSON.stringify({ username })
  };

  return fetch(generalConstants.BASE_URL + 'api/user/forgotpassword', requestOptions)
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then(user => {
      return user;
    });
}

function reset(password, selector, token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'x-api-key': generalConstants.API_KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, selector, token })
    };

    return fetch(generalConstants.BASE_URL + 'api/user/resetpassword', requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            return response.json();
        })
        .then(user => {
            return user;
        });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
  localStorage.removeItem('setting');
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader(),
      'x-api-key': generalConstants.API_KEY,
      'Content-Type': 'application/json'
    }
  };

  return fetch(generalConstants.BASE_URL + 'api/user/users', requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'x-api-key': generalConstants.API_KEY }
  };

  return fetch(generalConstants.BASE_URL + 'api/user/users/' + id, requestOptions).then(
    handleResponse
  );
}

function register(user) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  };

  return fetch(generalConstants.BASE_URL + 'api/user/users/', requestOptions).then(handleResponse);
}

function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'x-api-key': generalConstants.API_KEY,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(user)
  };

  return fetch(generalConstants.BASE_URL + 'api/user/users/' + user.id, requestOptions).then(
    handleResponse
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: { ...authHeader(), 'x-api-key': generalConstants.API_KEY }
  };

  return fetch(generalConstants.BASE_URL + 'api/user/users/' + id, requestOptions).then(
    handleResponse
  );
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }
  return response.json();
}



// WEBPACK FOOTER //
// ./src/services/user.service.js